/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import {
    forwardRef,
    ForwardRefRenderFunction,
    useEffect,
    useImperativeHandle
} from 'react'

import { ModalBuildHandle, ModalBuildProps } from './interfaces'
import { IconClose } from './styles'

export const ModalBuildFC: ForwardRefRenderFunction<
    ModalBuildHandle,
    ModalBuildProps
> = (
    {
        title,
        actions,
        shut = 'black',
        onConfirm,
        onCancel,
        onAfterClose,
        onAfterCloseRefresh,
        ...props
    },
    ref
) => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    const handleConfirm = () => onConfirm && onConfirm()

    const handleCancel = () => onCancel && onCancel()

    const handleAfterClose = () => onAfterClose && onAfterClose()

    const handleAfterCloseRefresh = () =>
        onAfterCloseRefresh && onAfterCloseRefresh()

    useEffect(() => {
        !isOpen && handleAfterClose
    }, [isOpen])

    useImperativeHandle(ref, () => {
        return {
            onOpen,
            onClose
        }
    })

    return (
        <Modal
            data-testid="modal"
            isCentered
            {...props}
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay data-testid="modal-overlay" />
            <ModalContent data-testid="modal-content">
                {title && (
                    <ModalHeader data-testid="modal-title">{title}</ModalHeader>
                )}
                {shut && (
                    <IconClose
                        name="close"
                        data-testid="modal-close-button"
                        color={shut}
                        onClick={() => {
                            onClose()
                            handleCancel()
                            handleAfterCloseRefresh()
                        }}
                    />
                )}

                <ModalBody p={0} data-testid="modal-body">
                    {props.children}
                </ModalBody>

                <ModalFooter
                    data-testid="modal-footer"
                    display="flex"
                    alignItems="center"
                    justifyContent={actions?.position || 'center'}
                    gap={6}
                >
                    {actions?.childrens?.map(
                        ({ text, handle, ...button }, key) => (
                            <Button
                                data-testid={`modal-${handle ?? 'button'}`}
                                {...button}
                                key={key}
                                onClick={
                                    handle &&
                                    (handle === 'confirm'
                                        ? handleConfirm
                                        : handleCancel)
                                }
                            >
                                {text}
                            </Button>
                        )
                    )}
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export const ModalBuild = forwardRef(ModalBuildFC)
